export class CodigoRegistro{
    correo_electronico:string='';
    codigo_registro:number=0;
    fecha_creacion!:Date;
    fecha_actualizacion!:Date;
    usuario_creacion:string ='';
    usuario_actualizacion!:string;
    es_valido:boolean=false;
    //
    id?:string
}